import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_auth = `${hostApi}/api/auth`;

function createToken(params) {
    return Vue.prototype.$http.post(`${api_auth}/userLogin`, params);
}

function createTokenWithId(id) {
    return Vue.prototype.$http.post(`${api_auth}/userLoginWithId/${id}`);
}

function refreshToken() {
    return Vue.prototype.$http.post(`${api_auth}/refreshToken`);
}

function getAuth() {
    return Vue.prototype.$http.post(`${api_auth}/me`);
}

function checkPassword(item) {
    return Vue.prototype.$http.post(`${api_auth}/pwCheck`, item);
}

function retry(originalRequest) {
    return Vue.prototype.$http(originalRequest);
}

function loginWithKakao(params) {
    return Vue.prototype.$http.post(`${api_auth}/kakaoLogin`, params);
}

function connectWithKakao(params) {
    return Vue.prototype.$http.post(`${api_auth}/kakaoConnect`, params);
}

function loginWithGoogle(params) {
    return Vue.prototype.$http.post(`${api_auth}/googleLogin`, params);
}

function connectWithGoogle(params) {
    return Vue.prototype.$http.post(`${api_auth}/googleConnect`, params);
}

function loginWithApple(params) {
    return Vue.prototype.$http.post(`${api_auth}/appleLogin`, params);
}

function connectWithApple(params) {
    return Vue.prototype.$http.post(`${api_auth}/appleConnect`, params);
}

export {
    createToken,
    createTokenWithId,
    refreshToken,
    getAuth,
    checkPassword,
    retry,
	loginWithKakao,
	connectWithKakao,
	loginWithGoogle,
	connectWithGoogle,
    loginWithApple,
    connectWithApple
};
